module.exports = __webpack_public_path__ + "static/media/powered.62ee69a3.svg";